import React, { useState, useEffect, useCallback } from 'react';
import Pagination from "react-js-pagination";
import {
  Box,
  HStack,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useDisclosure,
  Input,
  Flex,
  Card,
  Button,
  Heading,
  Icon,
  ModalFooter,
  Tag,
  VStack,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  Modal,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  useToast,
  Center
} from '@chakra-ui/react'

import { fetchWrapper } from '../../helpers';
import moment from 'moment';
import Header from '../../components/Header';
import 'moment-timezone';
import Select from "react-select";
import { LuBell, LuMail, LuMessageCircle, LuMessageSquare, LuPhone, LuExternalLink, LuRefreshCw, LuClock, LuFilter, LuFilterX, LuSmartphone, LuCheckCircle, LuXCircle, LuChevronDown, LuCheck } from 'react-icons/lu';
import { getUserTimeZone, hasPermission } from '../../utils/DefaultFunction';
import { Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";

import Prism from 'prismjs';
import "prismjs/components/prism-json";
import "prismjs/themes/prism-tomorrow.css";
import axios from 'axios';
import API from '../../helpers/axiosInstance';
import { useLocation, useSearchParams } from 'react-router-dom';
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper';

function MessageLogs({ header }) {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const toast = useToast();

  const getParamOption = (valueKey, labelKey) => {
    const value = searchParams.get(valueKey);
    const label = searchParams.get(labelKey);
    return value && label ? { value: isNaN(Number(value)) ? value : Number(value), label } : null;
  };
  const {
    isOpen: isPayloadOpen,
    onOpen: onPayloadOpen,
    onClose: onPayloadClose,
  } = useDisclosure();

  const user = JSON.parse(localStorage.getItem('customer'));
  const customer_id = JSON.parse(localStorage.getItem("customer"))?.customer_id;

  // Main data states
  const [statusList, setStatusList] = useState([]);
  const [list, setList] = useState([]);
  const [listCount, setListCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState(() => parseInt(searchParams.get('page') || '1'));
  const [totalItems, setTotalItems] = useState(0);
  const [stats, setStats] = useState({
    count: 0,
    delivered_read: 0,
    msgFail: 0,
    msgSentCount: 0,
    success_rate: 0,
  });
  const [isOpen, setIsOpen] = useState(false);

  // Filter data states
  const [channelData, setChannelData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [channelOptions, setchannelOptions] = useState([]);
  const [statusOptions, setstatusOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);

  // Filter states
  const [showFilters, setShowFilters] = useState(false);

  // Applied filter states (sent to API) - restored from URL on reload
  const [appliedChannel, setAppliedChannel] = useState(() => getParamOption('channel_value', 'channel_label'));
  const [appliedStatus, setAppliedStatus] = useState(() => getParamOption('status_value', 'status_label'));
  const [appliedStartDate, setAppliedStartDate] = useState(() => searchParams.get('start_date') || '');
  const [appliedEndDate, setAppliedEndDate] = useState(() => searchParams.get('end_date') || '');
  const [appliedCustomer, setAppliedCustomer] = useState(() => getParamOption('customer_id', 'customer_name'));

  // Temporary filter states (for UI only, until Apply is clicked) - also restored so filter panel shows current values
  const [selectedChannel, setSelectedChannel] = useState(() => getParamOption('channel_value', 'channel_label'));
  const [selectedStatus, setSelectedStatus] = useState(() => getParamOption('status_value', 'status_label'));
  const [selectedCustomer, setSelectedCustomer] = useState(() => getParamOption('customer_id', 'customer_name'));
  const [startDate, setStartDate] = useState(() => searchParams.get('start_date') || '');
  const [endDate, setEndDate] = useState(() => searchParams.get('end_date') || '');
  const [searchValue, setSearchValue] = useState(() => searchParams.get('search') || '');
  const [debouncedSearchValue, setDebouncedSearchValue] = useState(() => searchParams.get('search') || '');
  const [permissions, setPermissions] = useState([]);

  const [selectedMessage, setSelectedMessage] = useState("");
  const [autoRefreshInterval, setAutoRefreshInterval] = useState(0);
  const [selectedPayload, setSelectedPayload] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  const getApiHeaders = () => ({
    "x-api-key": localStorage.getItem('api-key'),
    "x-access-token": localStorage.getItem('customer-portal'),
  });

  const loadList = async () => {
    setLoading(true)
  
    try {
      const params = new URLSearchParams();

      const hasFilters =
        appliedChannel?.value ||
        appliedStatus?.value ||
        appliedStartDate ||
        appliedEndDate ||
        debouncedSearchValue.trim();

      // if (!hasFilters) {
        params.append("page", activePage);
      // }

      params.append("customer_id", appliedCustomer?.value || user?.customer_id || "");

      if (appliedChannel?.value) params.append("channel", appliedChannel.value);
      if (appliedStatus?.value) params.append("status", appliedStatus.value);
      if (appliedStartDate) params.append("start_date", moment(appliedStartDate).format("YYYY-MM-DD"));
      if (appliedEndDate) params.append("end_date", moment(appliedEndDate).format("YYYY-MM-DD"));
      if (debouncedSearchValue.trim()) params.append("search", debouncedSearchValue.trim());

      const url = `${process.env.REACT_APP_API_URL}/msg-log/list?${params.toString()}&pageSize=50`;
      const data = await fetchWrapper.get(url);
      
      const {
        count = 0,
        delivered_read = 0,
        msgFail = 0,
        msgSentCount = 0,
        success_rate = 0,
      } = data || {};
      
      setStats({ count, delivered_read, msgFail, msgSentCount, success_rate });
      setTotalItems(data.count || 0);
      setList(data.data || []);
      setListCount(data.count || 0);
      setLoading(false)
    } catch (error) {
      console.error("Error loading message logs:", error);
      setList([]);
      setListCount(0);
      setLoading(false)
    }finally{
      setLoading(false)
    }
  };

  const loadChannelList = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/channel/list`;
      const data = await fetchWrapper.get(url);
      setChannelData(data.data || []);
      setchannelOptions(data.data.map((item) => ({
        label: item?.name,
        value: item?.id
      })));
    } catch (error) {
      console.error('Error loading channels:', error);
    }
  };

  const loadStatusList = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/status/list`;
      const data = await fetchWrapper.get(url);
      setStatusData(data.data || []);
      setstatusOptions(data.data.map((item) => ({
        label: item?.name,
        value: item?.id
      })));
    } catch (error) {
      console.error('Error loading status list:', error);
    }
  };

  const loadCustomerList = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/customer/list`;
      const data = await fetchWrapper.get(url);
      setCustomerOptions((data.data || []).map((item) => ({
        label: item?.business_name,
        value: item?.id
      })));
    } catch (error) {
      console.error('Error loading customers:', error);
    }
  };

  const getStatusList = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/status/list`;
      const res = await fetchWrapper.get(url);
      setStatusList(res?.data || res || []);
    } catch (err) {
      console.error("Failed to load status list:", err);
    }
  };

  const fetchPermissions = async () => {
    try {
      const params = location.pathname.replace('/', "");
      const url = `${process.env.REACT_APP_API_URL}/permission/feature/list?slug=${params}`;
      const response = await API.get(url, { headers: getApiHeaders() });
      setPermissions(response.data.data || []);
    } catch (error) {
      console.error("Error fetching permissions:", error);
      setPermissions([]);
    }
  };

  // SINGLE INITIALIZATION - Runs ONCE on mount
  useEffect(() => {
    if (isInitialized) return;

    const initializeApp = async () => {
      // setLoading(true);
      
      try {
        // Fetch all reference data in parallel
        await Promise.all([
          loadChannelList(),
          loadStatusList(),
          getStatusList(),
          fetchPermissions(),
          loadCustomerList(),
        ]);

        // // Fetch initial list data
        // await loadList();

        setIsInitialized(true);
      } catch (error) {
        console.error("Initialization error:", error);
      } finally {
        // setLoading(false);
      }
    };

    initializeApp();
  }, []);

  // Debounced search effect - only after initialization
  useEffect(() => {
    if (!isInitialized) return;

    const timer = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
      setSearchParams(prev => {
        const params = new URLSearchParams(prev);
        if (searchValue.trim()) {
          params.set('search', searchValue.trim());
        } else {
          params.delete('search');
        }
        return params;
      });
    }, 500);

    return () => clearTimeout(timer);
  }, [searchValue, isInitialized]);

  // Sync page number to URL when it changes
  useEffect(() => {
    if (!isInitialized) return;
    setSearchParams(prev => {
      const params = new URLSearchParams(prev);
      params.set('page', activePage.toString());
      return params;
    });
  }, [activePage, isInitialized]);

  // Load data when filters change - only after initialization
  useEffect(() => {
    if (!isInitialized) return;

    loadList();
  }, [
    appliedChannel,
    appliedStatus,
    appliedStartDate,
    appliedEndDate,
    appliedCustomer,
    debouncedSearchValue,
    activePage,
    isInitialized
  ]);

  // Auto-refresh interval - only after initialization
  useEffect(() => {
    if (!isInitialized || !autoRefreshInterval) return;

    const interval = setInterval(() => {
      loadList();
    }, autoRefreshInterval);

    return () => clearInterval(interval);
  }, [
    autoRefreshInterval,
    appliedChannel,
    appliedStatus,
    appliedStartDate,
    appliedEndDate,
    debouncedSearchValue,
    activePage,
    isInitialized
  ]);

  const applyFilters = () => {
    setAppliedChannel(selectedChannel);
    setAppliedStatus(selectedStatus);
    setAppliedStartDate(startDate);
    setAppliedEndDate(endDate);
    setAppliedCustomer(selectedCustomer);
    setActivePage(1);
    setShowFilters(false);

    const params = new URLSearchParams();
    if (selectedCustomer) {
      params.set('customer_id', selectedCustomer.value);
      params.set('customer_name', selectedCustomer.label);
    }
    if (selectedChannel) {
      params.set('channel_value', selectedChannel.value);
      params.set('channel_label', selectedChannel.label);
    }
    if (selectedStatus) {
      params.set('status_value', selectedStatus.value);
      params.set('status_label', selectedStatus.label);
    }
    if (startDate) params.set('start_date', startDate);
    if (endDate) params.set('end_date', endDate);
    if (searchValue.trim()) params.set('search', searchValue.trim());
    params.set('page', '1');
    setSearchParams(params);
  };

  const clearFilters = () => {
    setSelectedChannel(null);
    setSelectedStatus(null);
    setSelectedCustomer(null);
    setStartDate('');
    setEndDate('');
    setAppliedChannel(null);
    setAppliedStatus(null);
    setAppliedCustomer(null);
    setAppliedStartDate('');
    setAppliedEndDate('');
    setSearchValue('');
    setActivePage(1);
    setSearchParams({});
  };

  const handleCustomerChange = (option) => {
    setSelectedCustomer(option);
    setAppliedCustomer(option);
    setActivePage(1);
    setSearchParams(prev => {
      const params = new URLSearchParams(prev);
      if (option) {
        params.set('customer_id', option.value);
        params.set('customer_name', option.label);
      } else {
        params.delete('customer_id');
        params.delete('customer_name');
      }
      params.set('page', '1');
      return params;
    });
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const Channels = [
    {
      name: "Whatsapp",
      icon: LuMessageCircle,
      color: "#00a63e",
      description: "Rich messaging with media and buttons",
      id: 2,
    },
    {
      name: "SMS",
      icon: LuMessageSquare,
      color: "#155dfc",
      description: "Simple text messages",
      id: 1,
    },
    {
      name: "E-Mail",
      icon: LuMail,
      color: "#9810fa",
      description: "HTML emails with rich content",
      id: 3,
    },
    {
      name: "Push Notification",
      icon: LuBell,
      color: "#e60076",
      description: "Mobile app notifications",
      id: 6,
    },
    {
      name: "In-App Notification",
      icon: LuBell,
      color: "#4f39f6",
      description: "In-app messages and alerts",
      id: 5,
    },
    {
      name: "Voice (IVR)",
      icon: LuPhone,
      color: "#f54a00",
      description: "Automated voice calls",
      id: 4,
    },
  ];

  const getChannelInfo = (channelIdOrName) => {
    return (
      Channels.find(
        (c) => c.id === channelIdOrName || c.name === channelIdOrName
      ) || { name: "System", icon: LuSmartphone, color: "gray" }
    );
  };

  const openModal = (msg) => {

    setSelectedMessage(msg);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelectedMessage(null);
  };

  const getStatusDetails = (statusId) => {
    return statusList.find((s) => s.status_id === statusId || s.id === statusId);
  };

  const getStatusColor = (statusName) => {
    const name = statusName?.toLowerCase() || "";
    if (name.includes("read") || name.includes("delivered")) return "green";
    if (name.includes("sent")) return "blue";
    if (name.includes("fail") || name.includes("undeliverable")) return "red";
    if (name.includes("accept")) return "green";
    return "gray";
  };

  const regexCheckHtml = /<[a-zA-Z][^>]*>/;

  const getIntervalLabel = (interval) => {
    switch (interval) {
      case 30000:
        return "30s";
      case 60000:
        return "1m";
      case 300000:
        return "5m";
      default:
        return "OFF";
    }
  };

  const handleViewPayload = (payload) => {
    const parsedPayload = JSON.parse(JSON.stringify(payload, (key, value) => {
      if (typeof value === "string" && value.startsWith("{") && value.endsWith("}")) {
        try {
          return JSON.parse(value);
        } catch {
          return value;
        }
      }
      return value;
    }));

    const formatted = JSON.stringify(parsedPayload, null, 2);
    setSelectedPayload(formatted);
    onPayloadOpen();

    setTimeout(() => Prism.highlightAll(), 0);
  };

  const downloadCSV = async () => {
    try {
      setIsDownloading(true);

      const params = new URLSearchParams();
      params.append("customer_id", appliedCustomer?.value || customer_id || "");

      if (appliedChannel?.value) params.append("channel", appliedChannel.value);
      if (appliedStatus?.value) params.append("status", appliedStatus.value);
      if (appliedStartDate) params.append("start_date", moment(appliedStartDate).format("YYYY-MM-DD"));
      if (appliedEndDate) params.append("end_date", moment(appliedEndDate).format("YYYY-MM-DD"));
      if (debouncedSearchValue.trim()) params.append("search", debouncedSearchValue.trim());

      const constructedUrl = `${process.env.REACT_APP_API_URL}/msg-log/export-data?${params.toString()}`;

      const response = await API.get(constructedUrl, {
        headers: getApiHeaders(),
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `messages_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting CSV:", error);
      toast({
        title: "Export Failed",
        description: "Something went wrong while downloading the CSV file.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setIsDownloading(false);
    }
  };

  const listPermission = hasPermission("dr-list", permissions);
  const exportPermission = hasPermission("dr-export", permissions);
  const viewPaylaodPermission = hasPermission("dr-view-payload", permissions);

  if (loading) {
    return (
      <>
        <Header header={header} />
        <BoxWrapper>
          <HStack justifyContent="space-between" alignItems="center" mb={4}>
            <Text fontSize="xl" color="grey.400" fontWeight={"medium"}>Delivery Logs</Text>

            <HStack spacing={4}>
              <Box minW="300px">
                <Input
                  placeholder="Search by Message ID, recipient"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  size={"sm"}
                  isDisabled={true}
                />
              </Box>
              <Box minW="200px">
                <Select
                  options={customerOptions}
                  placeholder="All Customers"
                  value={selectedCustomer}
                  onChange={handleCustomerChange}
                  isClearable
                  isSearchable
                  isDisabled={true}
                />
              </Box>
              {exportPermission && (
                <Button
                  size="sm"
                  bg="#2563eb"
                  isLoading={isDownloading}
                  color="white"
                  onClick={downloadCSV}
                  isDisabled={true}
                >
                  Export
                </Button>
              )}
              <HStack spacing={0} borderWidth="1px" borderRadius="md" overflow="hidden">
                <Button
                  size="sm"
                  bg="#2563eb"
                  borderRightRadius={0}
                  color="white"
                  leftIcon={<Icon as={LuRefreshCw} boxSize={3} />}
                  onClick={() => loadList()}
                  isDisabled={true}
                >
                  Refresh
                </Button>
                <Menu>
                  <MenuButton
                    as={Button}
                    size="sm"
                    variant="solid"
                    bg="#2563eb"
                    borderLeftRadius={0}
                    px={2}
                    color={"white"}
                    rightIcon={<Icon as={LuChevronDown} boxSize={3} />}
                    isDisabled={true}
                  >
                    {autoRefreshInterval !== 0 && (
                      <Text ml={2} fontSize="xs" opacity={0.8}>
                        {getIntervalLabel(autoRefreshInterval)}
                      </Text>
                    )}
                  </MenuButton>
                  <MenuList minW="120px">
                    <MenuItem onClick={() => setAutoRefreshInterval(0)}>
                      OFF {autoRefreshInterval === 0 && <Icon as={LuCheck} ml="auto" />}
                    </MenuItem>
                  </MenuList>
                </Menu>
              </HStack>
              <Button
                onClick={toggleFilters}
                colorScheme="blue"
                variant={showFilters ? "solid" : "outline"}
                size="sm"
                className='updated-chakra-button'
                isDisabled={true}
              >
                {showFilters ? <LuFilterX /> : <LuFilter />}
              </Button>
            </HStack>
          </HStack>

          <div className="table_section">
            <TableContainer width="100%">
              <Table>
                <Thead>
                  <Tr>
                    <Th w="200px">Message ID</Th>
                    <Th w="160px">Recipient</Th>
                    <Th w="200px">Message</Th>
                    <Th w="180px">Channel</Th>
                    <Th w="80px">Count</Th>
                    <Th w="220px">Cost</Th>
                    <Th w="180px">Date & Time</Th>
                    <Th w="190px">Status</Th>
                  </Tr>
                </Thead>

                <Tbody w={"100%"}>
                  <Tr w={"100%"}>
                    <Td colSpan={12} textAlign="center" py={8} w={"100%"}>
                      <Center h="400px">
                        <VStack spacing={4}>
                          <div className="page-loader-ring" />
                          <Text fontSize="sm" color="gray.400" fontWeight="400">
                            Loading messages...
                          </Text>
                        </VStack>
                      </Center>
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
            </TableContainer>
          </div>
        </BoxWrapper>
      </>
    );
  }

  const getTypeId = (typeId) => {
    switch (typeId) {
      case 1:
        return "Authentication";
      case 2:
        return "Transactional";
      case 3:
        return "Marketing";
      case 4:
        return "Informational";
      default:
        return "Unknown";
    }
  }
  return (
    <>
      <Header header={header} />

      <BoxWrapper>


        <HStack justifyContent="space-between" alignItems="center" mb={4}>
          <Text fontSize="xl" color="grey.400" fontWeight={"medium"}>Delivery Logs</Text>

          {/* Search and Filter Toggle */}
          <HStack spacing={4}>
            <Box minW="300px">
              <Input
                placeholder="Search by Message ID, recipient"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                size={"sm"}
              />
            </Box>
            <Box minW="200px">
              <Select
                options={customerOptions}
                placeholder="All Customers"
                value={selectedCustomer}
                onChange={handleCustomerChange}
                isClearable
                isSearchable
              />
            </Box>
            {exportPermission && (

              <Button
                size="sm"
                bg="#2563eb"
                isLoading={isDownloading}
                color="white"
                // leftIcon={<Icon as={LuRefreshCw} boxSize={3} />}
                onClick={downloadCSV}
              >
                Export

              </Button>
            )}
            <HStack spacing={0} borderWidth="1px" borderRadius="md" overflow="hidden">
              {/* Refresh Button */}
              <Button
                size="sm"
                bg="#2563eb"
                borderRightRadius={0}
                color="white"
                leftIcon={<Icon as={LuRefreshCw} boxSize={3} />}
                onClick={() =>
                  loadList()
                }
              >
                Refresh

              </Button>
              {/* Auto Refresh Dropdown */}
              <Menu>
                <MenuButton
                  as={Button}
                  size="sm"
                  variant="solid"
                  bg="#2563eb"
                  borderLeftRadius={0}
                  px={2}
                  color={"white"}

                  rightIcon={<Icon as={LuChevronDown} boxSize={3} />}
                >{autoRefreshInterval !== 0 && (
                  <Text ml={2} fontSize="xs" opacity={0.8}>
                    {getIntervalLabel(autoRefreshInterval)}
                  </Text>
                )}</MenuButton>
                <MenuList minW="120px">
                  <MenuItem onClick={() => setAutoRefreshInterval(0)}>
                    OFF {autoRefreshInterval === 0 && <Icon as={LuCheck} ml="auto" />}
                  </MenuItem>
                  <MenuItem onClick={() => setAutoRefreshInterval(30000)}>
                    Every 30s {autoRefreshInterval === 30000 && <Icon as={LuCheck} ml="auto" />}
                  </MenuItem>
                  <MenuItem onClick={() => setAutoRefreshInterval(60000)}>
                    Every 1m {autoRefreshInterval === 60000 && <Icon as={LuCheck} ml="auto" />}
                  </MenuItem>
                  <MenuItem onClick={() => setAutoRefreshInterval(300000)}>
                    Every 5m {autoRefreshInterval === 300000 && <Icon as={LuCheck} ml="auto" />}
                  </MenuItem>
                </MenuList>
              </Menu>
            </HStack>
            <Button
              onClick={toggleFilters}
              colorScheme="blue"
              variant={showFilters ? "solid" : "outline"}
              size="sm"
              className='updated-chakra-button'
            >
              {showFilters ? <LuFilterX /> : <LuFilter />}
            </Button>
          </HStack>
        </HStack>

        {/* Toggleable Filters Card */}
        {showFilters && (
          <Box className='box-style-card' mb={4}>
            <Heading size="sm" mb={4} color="gray.600">Filter Options</Heading>

            {/* Date Range Filters */}
            <HStack spacing={4} mb={4} wrap="wrap">
              <Box minW="200px">
                <Text fontSize="sm" mb={2} color="gray.600">Start Date:</Text>
                <Input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </Box>

              <Box minW="200px">
                <Text fontSize="sm" mb={2} color="gray.600">End Date:</Text>
                <Input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </Box>
              <Box minW="200px">
                <Text fontSize="sm" mb={2} color="gray.600">Channel:</Text>
                <Select
                  options={channelOptions}
                  placeholder="All Channels"
                  value={selectedChannel}
                  onChange={setSelectedChannel}
                  isClearable
                />
              </Box>

              <Box minW="200px">
                <Text fontSize="sm" mb={2} color="gray.600">Status:</Text>
                <Select
                  options={statusOptions}
                  placeholder="All Status"
                  value={selectedStatus}
                  onChange={setSelectedStatus}
                  isClearable
                />
              </Box>

            </HStack>


            {/* Filter Action Buttons */}
            <HStack spacing={3} justifyContent="flex-end">
              <Button
                onClick={clearFilters}
                variant="outline"
                colorScheme="gray"
                size="sm"
              >
                Clear Filters
              </Button>

              <Button
                onClick={applyFilters}
                colorScheme="blue"
                size="sm"
                className='updated-chakra-button'
              >
                Apply Filters
              </Button>
            </HStack>


          </Box>
        )}

        {/* Active Filters Display */}
        {(appliedChannel || appliedStatus || appliedCustomer || appliedStartDate || appliedEndDate || debouncedSearchValue) && (
          <Box className='box-style-card' mb={4}>
            <Text fontSize="sm" fontWeight="semibold" color="blue.800" mb={2}>Active Filters:</Text>
            <HStack spacing={2} wrap="wrap">
              {appliedCustomer && (
                <Box bg="blue.100" px={2} py={1} borderRadius="md" fontSize="xs">
                  Customer: {appliedCustomer.label}
                </Box>
              )}
              {appliedChannel && (
                <Box bg="blue.100" px={2} py={1} borderRadius="md" fontSize="xs">
                  Channel: {appliedChannel.label}
                </Box>
              )}
              {appliedStatus && (
                <Box bg="blue.100" px={2} py={1} borderRadius="md" fontSize="xs">
                  Status: {appliedStatus.label}
                </Box>
              )}
              {appliedStartDate && (
                <Box bg="blue.100" px={2} py={1} borderRadius="md" fontSize="xs">
                  From: {moment(appliedStartDate).format('DD/MM/YYYY')}
                </Box>
              )}
              {appliedEndDate && (
                <Box bg="blue.100" px={2} py={1} borderRadius="md" fontSize="xs">
                  To: {moment(appliedEndDate).format('DD/MM/YYYY')}
                </Box>
              )}
              {debouncedSearchValue && (
                <Box bg="blue.100" px={2} py={1} borderRadius="md" fontSize="xs">
                  Search: "{debouncedSearchValue}"
                </Box>
              )}
            </HStack>
          </Box>
        )}
       <div className="table_section">
            <TableContainer width="100%">
            <Table >
              <Thead >
                <Tr>
                  <Th w="100px">Message ID</Th>
                  <Th w="160px">Recipient</Th>
                  <Th w="200px">Message</Th>
                  <Th w="180px">Channel</Th>
                  <Th w="80px">Count</Th>
                  <Th w="220px">Cost</Th>
                  <Th w="180px">Date & Time</Th>
                  <Th w="250px">Status</Th>
                </Tr>
              </Thead>

              <Tbody>
                {
                  list.map((item) => (
                    <Tr key={item._id}>
                      <Td
                        whiteSpace="nowrap"
                        color="#2563eb"
                        cursor="pointer"
                        onClick={() => openModal(item)}
                        _hover={{ textDecoration: "underline" }}
                      >
                        <HStack spacing={1}>
                          <Text>{item._id.slice(0, 8)}...</Text>
                          <Icon as={LuExternalLink} />
                        </HStack>
                      </Td>

                      <Td whiteSpace="nowrap">{item.to || "—"}</Td>

                      <Td
                        maxW="200px"
                        whiteSpace="nowrap"
                        overflow="hidden"
                        textOverflow="ellipsis"
                        title={regexCheckHtml.test(item.message) ? null : item.message}
                      >
                        {regexCheckHtml.test(item.message) ? (
                          <Popover placement="auto" closeOnBlur>
                            <PopoverTrigger>
                              <Text
                                color="#2563eb"
                                cursor="pointer"
                                isTruncated
                              >
                                This message contains HTML. Click to preview.
                              </Text>
                            </PopoverTrigger>

                            <PopoverContent w="max-content" maxW="90vw">
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverHeader fontWeight="semibold">HTML Preview</PopoverHeader>
                              <PopoverBody>
                                <Box maxH="400px" overflowY="auto" borderRadius="md">
                                  <iframe
                                    srcDoc={item.message} // Render the HTML content
                                    title="HTML Preview"
                                    style={{
                                      width: "100%",
                                      height: "auto",
                                      border: "none",
                                      borderRadius: "6px",
                                      background: "white",
                                    }}
                                    sandbox="allow-same-origin" // optional for security
                                  />
                                </Box>
                              </PopoverBody>
                            </PopoverContent>
                          </Popover>
                        ) : (
                          item.message || "—"
                        )}

                      </Td>
                      <Td>
                        {(() => {
                          const channel =
                            Channels.find((c) => c.id === item?.MsgChannel?.id) ||
                            Channels.find((c) => c.name === item?.MsgChannel?.name);
                          const IconComp = channel?.icon || LuSmartphone;
                          const color = channel?.color || "gray";

                          return (
                            <HStack spacing={2}>
                              <Icon as={IconComp} color={`${color}`} boxSize={4} />
                              <Text fontSize="sm" fontWeight="thin">
                                {channel?.name === "In-App Notification" ? "In-App" : channel?.name || "N/A"}

                              </Text>
                            </HStack>
                          );
                        })()}

                      </Td>

                      <Td>{item?.message_count ?? 1}</Td>

                      <Td fontSize="xs" whiteSpace="nowrap">
                        <Text>Cost: {item?.price ?? '-'}</Text>
                        <Text>Saving: {item?.saving ?? '-'}</Text>
                        <Text>Decision Charges: {item?.api_charges ?? '-'}</Text>
                      </Td>




                      <Td whiteSpace="nowrap" verticalAlign="top">
                        <VStack align="flex-start" spacing={0}>
                          <Text color="#64748b" fontSize="xs">
                            Received:{" "}
                            {/* <strong style={{ color: "black" }}> */}
                              {moment
                                .utc(item.receive_date)
                                .tz(getUserTimeZone())
                                .format("DD MMM YY hh:mm:ss A")}
                            {/* </strong> */}
                          </Text>
                          <Text color="#64748b" fontSize="xs">
                            Sent:{" "}
                            {moment
                              .utc(item.sent_date)
                              .tz(getUserTimeZone())
                              .format("DD MMM YY hh:mm:ss A")}
                          </Text>
                        </VStack>
                      </Td>



                      <Td whiteSpace="nowrap">
                        <HStack
                          spacing={1.5}
                          display="inline-flex"
                          alignItems="center"
                          px={2.5}
                          py={1}
                          borderRadius="full"
                          border="1px solid"
                          borderColor={`${item?.Status?.color || "gray"}.200`}
                          bg={`${item?.Status?.color || "gray"}.50`}
                        >
                          <Box
                            w="6px"
                            h="6px"
                            borderRadius="full"
                            bg={`${item?.Status?.color || "gray"}.500`}
                            flexShrink={0}
                          />
                          <Text
                            fontSize="xs"
                            color={`${item?.Status?.color || "gray"}.700`}
                            fontWeight="500"
                            whiteSpace="nowrap"
                          >
                            {item?.Status?.name || "Unknown"}
                          </Text>
                        </HStack>
                      </Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
            </TableContainer>

            {totalItems > 0 && (
              <Flex justify="center" mt={6}>
                <Pagination
                  activePage={activePage}
                  itemsCountPerPage={50}
                  totalItemsCount={totalItems}
                  pageRangeDisplayed={5}
                  onChange={(page) => setActivePage(page)}
                  itemClass="page-item"
                  linkClass="page-link"
                  innerClass="pagination"
                />
              </Flex>
            )}
          </div>





        <Modal isOpen={isOpen} onClose={closeModal} size="xl" isCentered>
          <ModalOverlay />
          <ModalContent maxW="600px">
            <ModalHeader
              borderBottom="1px"
              borderColor="gray.200"
              pb={3}
              fontSize="lg"
              fontWeight="semibold"
            >
              <HStack spacing={2}>
                <Icon as={LuClock} color="blue.500" />
                <Text>Message Delivery Journey</Text>
              </HStack>
            </ModalHeader>
            <ModalCloseButton />

            <ModalBody py={4}>
              {selectedMessage ? (
                <VStack align="stretch" spacing={4}>
                  {/* Message ID */}
                  <Box bg="gray.50" borderRadius="md">
                    <Box bg="red.50" boxShadow="sm" borderRadius="lg" border={1} borderColor="red.200" borderStyle="solid" mb={2}>
                      <Text fontSize="xs" color="black" p={2}>
                        <Flex justifyContent={"space-between"} alignItems={"center"}>
                          <strong> Message Id: {selectedMessage.messageid || selectedMessage._id}</strong>
                         <Button size={"xs"} bg={"#2563ebe6"} color={"white"} onClick={() => handleViewPayload(selectedMessage.customer_payload)}>View Payload</Button>

                        </Flex>
                      </Text>
                    </Box>
                    <Text fontSize="sm" color="gray.600">
                      Complete delivery timeline showing channel-specific status
                      progression and auto-failover attempts.
                    </Text>
                  </Box>

                  {/* Info Grid */}
                  <Box
                    bg="blue.50"
                    border="1px"
                    borderColor="blue.200"
                    borderRadius="md"
                    p={3}
                  >
                    <Flex justify="space-between" mb={2}>
                      <Box flex="1">
                        <Text fontSize="xs" color="gray.600" mb={1}>
                          Recipient
                        </Text>
                        <Text fontSize="xs" fontWeight="semibold">
                          {selectedMessage.to || "-"}
                        </Text>
                      </Box>
                      <Box flex="1">
                        <Text fontSize="xs" color="gray.600" mb={1}>
                          Message Type
                        </Text>
                        <Tag fontSize="xs" fontWeight="normal" border={"1px"} borderColor="gray.300"
                          color={"black"}
                          bg="white">
                            {getTypeId(selectedMessage.message_type_id)}
                          
                        </Tag>
                      </Box>
                      <Box flex="1">
                        <Text fontSize="xs" color="gray.600" mb={1}>
                          Final Status
                        </Text>
                        <Tag
                          colorScheme={getStatusColor(selectedMessage?.Status?.name)}
                          px={2}
                          py={1}
                          borderRadius="md"
                        >
                          {selectedMessage?.Status?.name || "Unknown"}
                        </Tag>
                      </Box>


                    </Flex>
                    <Box>
                      {selectedMessage.message && (
                        <>
                          <Text fontSize="xs" color="gray.600" mb={2} fontWeight="medium">
                            Message Content
                          </Text>
                          <Box bg="white" border={1} borderColor={"gray.100"} p={3} borderRadius="md">
                            {regexCheckHtml.test(selectedMessage.message) ? <Box
                              maxH="400px"
                              overflowY="auto"
                              borderRadius="md"
                            >
                              <iframe
                                srcDoc={selectedMessage.message}
                                title="HTML Message"
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  border: "none",
                                  borderRadius: "6px",

                                }}
                                sandbox="allow-same-origin"
                              />
                            </Box>
                              : <Text fontSize="sm">{selectedMessage.message}</Text>}

                          </Box>
                        </>
                      )}

                    </Box>

                  </Box>



                  <Box>
                    <HStack spacing={2} mb={3}>
                      <Icon as={LuClock} color="blue.500" boxSize={4} />
                      <Text fontSize="sm" fontWeight="semibold">
                        Delivery Timeline & Status Progression
                      </Text>
                    </HStack>

                    <VStack align="stretch" spacing={0} pl={2}>
                      {selectedMessage.history?.map((h, i) => {
                        const status = getStatusDetails(h.status_id);


                        const { name: channelName, icon: ChannelIcon, color: channelColor } = getChannelInfo(h.channel_id);



                        const isFailed = status?.name?.toLowerCase().includes("fail") ||
                          status?.name?.toLowerCase().includes("undeliverable");


                        const currentIndex = selectedMessage.history.findIndex((item) => item === h);
                        const nextStatus = selectedMessage.history[currentIndex + 1];
                        const nextStatusDetails = nextStatus ? getStatusDetails(nextStatus.status_id) : null;

                        const isNextNotFailed =
                          nextStatusDetails &&
                          !nextStatusDetails?.name?.toLowerCase().includes("fail") &&
                          !nextStatusDetails?.name?.toLowerCase().includes("undeliverable");


                        const shouldTriggerFailover = isFailed && isNextNotFailed;


                        const getCooloredStatus = (status) => {
                          if (!status) return "white";
                          const name = status.name?.toLowerCase() || "";

                          if (name.includes("read") || name.includes("delivered")) return "#f0fdf4";
                          if (name.includes("sent")) return "#eff6ff";
                          if (name.includes("clicked")) return "#f0fdf4";
                          if (name.includes("fail") || name.includes("undeliverable")) return "#fef2f2";
                          if (name.includes("invalid") || name.includes("undeliverable")) return "#fef2f2";
                          if (name.includes("accept")) return "white";
                          return "white";
                        }
                        const getCooloredBorderedStatus = (status) => {
                          if (!status) return "gray";
                          const name = status.name?.toLowerCase() || "";

                          if (name.includes("read") || name.includes("delivered")) return "#00c951";
                          if (name.includes("clicked") || name.includes("delivered")) return "#00c951";
                          if (name.includes("sent")) return "#2b7fff";
                          if (name.includes("fail") || name.includes("undeliverable")) return "#fb2c36";
                          if (name.includes("invalid") || name.includes("undeliverable")) return "#fb2c36";
                          if (name.includes("accept")) return "#6a7282";
                          return "gray";
                        }

                        return (
                          <Flex key={i}>
                            <Box
                              flex="1"
                              bg={getCooloredStatus(status)}
                              border="1px"
                              borderColor={getCooloredStatus(status)}
                              borderLeftWidth="4px"
                              borderLeftColor={getCooloredBorderedStatus(status)}
                              borderRadius="md"
                              my={3}
                              px={2}
                              py={5}
                            >
                              {/* ✅ Left icon + Right content */}
                              <Flex align="start" gap={3}>
                                {/* Left icon */}
                                {status.msg_status === "1" ? (
                                  <LuCheckCircle color="#00a63e" boxSize={4} />
                                ) : (
                                  <LuXCircle color="#e7000b" boxSize={4} />
                                )}

                                {/* Right content */}
                                <Box flex="1">
                                  <Flex justify="space-between" align="start" mb={1}>
                                    <HStack spacing={2}>
                                      {h.channel_id ? (
                                        <HStack spacing={1}>
                                          <Icon as={ChannelIcon} color={`${channelColor}`} boxSize={3.5} />
                                          <Text fontSize="xs" fontWeight="semibold">
                                            {channelName}
                                          </Text>
                                        </HStack>
                                      ) : (
                                        <Text fontSize="xs" fontWeight="semibold">
                                          {channelName}
                                        </Text>
                                      )}
                                      {status.msg_status === "0" && <Tag bg={"red"} size={"sm"} color={"white"}>Failed</Tag>}
                                      <Tag
                                        size="sm"
                                        border="1px solid"
                                        borderColor="gray.300"
                                        color={status.name?.toLowerCase().includes("accept") ? "black" : "#64748b"}
                                        bg="transparent"
                                      >
                                        {status?.name || `Status ${h.status_id}`}
                                      </Tag>
                                    </HStack>

                                    <Text fontSize="xs" color="gray.500">
                                      {new Date(h.time).toLocaleString("en-PK", {
                                        dateStyle: "short",
                                        timeStyle: "medium",
                                      })}
                                    </Text>
                                  </Flex>
                                  {h.channel_id == 5 || h.channel_id == 6 && (
                                    <>
                                      {h.subscriber_id && (
                                        <Text fontSize="xs" color="gray.600">Subscriber Id : {h.subscriber_id}</Text>

                                      )}
                                    </>
                                  )}
                                  <Text fontSize="xs" color="gray.600">
                                    {status?.description ||
                                      (isFailed
                                        ? "Message Undeliverable - Customer not on platform"
                                        : status?.name === "Message Accepted"
                                          ? "Message Accepted - Request received and validated"
                                          : status?.name === "Message Sent"
                                            ? `Message Sent to ${channelName}`
                                            : status?.name === "Message Delivered"
                                              ? "Message Delivered"
                                              : status?.name === "Message Read"
                                                ? "Message Read"
                                                : "")}
                                  </Text>

                                  {shouldTriggerFailover && (
                                    <Text
                                      fontSize="xs"
                                      color="#ca3500"
                                      bg="#ffedd4"
                                      px={2}
                                      py={1}
                                      mt={2}
                                      borderRadius="md"
                                      fontWeight="medium"
                                    >
                                      → Triggering auto-failover to next channel
                                    </Text>
                                  )}
                                </Box>
                              </Flex>
                            </Box>
                          </Flex>
                        );
                      })}
                    </VStack>
                  </Box>
                </VStack>
              ) : (
                <Text>No details available.</Text>
              )}
            </ModalBody>

            <ModalFooter borderTop="1px" borderColor="gray.200">
              <Button onClick={closeModal} size={"sm"} bg="#2563eb"

                color="white">
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>



        <Modal isOpen={isPayloadOpen} onClose={onPayloadClose} size="4xl">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Payload Details</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {selectedPayload ? (
                <Box
                  maxH="400px"
                  overflowY="auto"
                  // bg="gray.900"
                  color="green.200"
                  // p={4}
                  borderRadius="md"
                >
                  <pre
                    style={{
                      backgroundColor: "black",
                      textShadow: "none",
                      color: "white",
                      padding: "0px",
                      borderRadius: "8px",
                      fontFamily: "monospace",

                    }}
                  >
                    <span
                      style={{
                        padding: 15,
                        backgroundColor: "#2F2F2F",
                        fontSize: "14px",
                        display: "block",
                        marginBottom: "10px",

                      }}
                    >
                      json
                    </span>

                    <code
                      className="language-json"
                      style={{ padding: "0px 15px 15px", display: "block", whiteSpace: "pre-wrap" }}
                      dangerouslySetInnerHTML={{ __html: Prism.highlight(selectedPayload, Prism.languages.json, 'json') }}
                    />
                  </pre>

                </Box>
              ) : (
                <Text>No payload found.</Text>
              )}

              {(() => {
                const raw = selectedMessage?.error_log;
                if (!raw || (Array.isArray(raw) && raw.length === 0)) return null;

                let errorLogs = raw;
                if (typeof raw === 'string') {
                  try { errorLogs = JSON.parse(raw); } catch { errorLogs = null; }
                }

                return (
                  <Box mt={4}>
                    <Text fontWeight="semibold" fontSize="sm" mb={2} color="red.700">Error Log</Text>
                    {Array.isArray(errorLogs) ? (
                      errorLogs.map((err, i) => (
                        <Box key={i} bg="red.50" border="1px" borderColor="red.200" borderRadius="md" p={3} mb={2}>
                          <HStack spacing={2} mb={1}>
                            <Text fontSize="xs" fontWeight="bold" color="red.700">{err.title}</Text>
                            <Text fontSize="xs" color="gray.500">(Code: {err.code})</Text>
                          </HStack>
                          {err.error_data?.details && (
                            <Text fontSize="xs" color="gray.700">{err.error_data.details}</Text>
                          )}
                          {err.href && (
                            <Text fontSize="xs" color="blue.500" mt={1} as="a" href={err.href} target="_blank" rel="noreferrer">
                              {err.href}
                            </Text>
                          )}
                        </Box>
                      ))
                    ) : (
                      <Box bg="red.50" border="1px" borderColor="red.200" borderRadius="md" p={3}>
                        <Text fontSize="xs" color="red.700" whiteSpace="pre-wrap">{typeof raw === 'string' ? raw : JSON.stringify(raw)}</Text>
                      </Box>
                    )}
                  </Box>
                );
              })()}
            </ModalBody>
            <ModalFooter>
              <Button onClick={onPayloadClose} size={"sm"} bg="#2563eb"

                color="white">Close</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </BoxWrapper>
    </>
  )
}

export default MessageLogs;